import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { supabase } from '../lib/supabase';

const SubscriptionSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [nameShort, setNameShort] = useState<string>('');
  const [isMale, setIsMale] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;
        const { data: profile } = await supabase
          .from('profiles')
          .select('name_short, name_sex_male')
          .eq('id', user.id)
          .single();
        if (profile) {
          setNameShort((profile as any).name_short || '');
          const male = (profile as any)?.name_sex_male === null ? true : !!(profile as any)?.name_sex_male;
          setIsMale(male);
        }
      } catch {}
    })();
  }, []);

  return (
    <div className="w-full min-h-[100dvh] md:min-h-screen md:flex md:items-center md:justify-center bg-surface-card md:bg-transparent">
      <div className="relative bg-surface-card w-full min-h-[100dvh] md:min-h-0 px-4 md:px-8 py-10 md:py-12 pb-28 md:pb-12 md:max-w-4xl md:mx-auto md:rounded-lg md:border md:border-neutral-200 flex items-center justify-center">
        <div className="max-w-md w-full text-center">
          <div className="mx-auto mb-6 w-16 h-16 rounded-md bg-green-50 border border-green-200 flex items-center justify-center">
            <Check className="w-8 h-8 text-green-600" />
          </div>
          <h1 className="text-[17px] font-semibold text-brand-black/90 mb-2">Subscripción exitosa.</h1>
          <p className="text-[15px] text-neutral-600">
            {`${nameShort ? `${nameShort}, ` : ''}${isMale ? 'bienvenido' : 'bienvenida'} a la revolución de la IA.`}
          </p>
          {/* Desktop inline helper + button */}
          <div className="hidden md:block mt-8">
            <p className="text-[13px] text-neutral-400 mb-3">Ante cualquier duda te podes comunicar con nostros yendo a la pestaña de Ayuda.</p>
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center justify-center h-10 px-5 bg-brand-primary hover:bg-brand-primary-hover text-white text-[15px] font-medium rounded-md shadow-sm transition-colors"
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
      {/* Mobile fixed bottom actions */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-surface-card px-4 py-4 border-t border-neutral-200">
        <p className="text-[13px] text-neutral-400 mb-2 text-center">Ante cualquier duda te podes comunicar con nostros yendo a la pestaña de ayuda.</p>
        <button
          onClick={() => navigate('/')}
          className="w-full h-10 bg-brand-primary hover:bg-brand-primary-hover text-white text-[15px] font-medium rounded-md shadow-sm transition-colors"
        >
          Continuar
        </button>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
